const initialState = {
    loading: true,
    menuItems: [],
    corporate: [],
    clients: [],
    currentCorporate: 0,
    isInternalUser: false,
    helpFile: null,
    indicator: "",
    corporateSelect: true,
    notification: {},
    countDetails: {},
    statusCode: [],
    statusCodeList: [],
    holdReason: [],
    paymentTransactions: []
};

const items = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD_ITEM':
            return {
                ...state,
                [action.key]: action.value
            }
        case 'USER_LOGOUT':
            return initialState;
        case 'LOAD':
            return {
                ...state,
                [action.key]: action.value
            }
        case 'UNLOAD':
            return {
                ...state,
                [action.key]: action.value
            }
        default:
            return state;
    }
}
export default items


// WEBPACK FOOTER //
// ./src/app/utils/reducers/items.js